<template>
    <v-row class="mr-1" dense>
      <v-col cols="2" class="pa-0 px-1">
        <v-text-field
          class="rm-fieldset-mr"
          v-model="localHijri.day"
          outlined
          dense
          hide-details
          label="ي"
          type="number"
          min="1"
          max="30"
        />
      </v-col>
      <v-col cols="2" class="pa-0 px-1">
        <v-text-field
          class="rm-fieldset-mr"
          v-model="localHijri.month"
          outlined
          dense
          hide-details
          label="ش"
          type="number"
          min="1"
          max="12"
        />
      </v-col>
      <v-col cols="3" class="pa-0 px-1">
        <v-text-field
          class="rm-fieldset-mr"
          v-model="localHijri.year"
          outlined
          dense
          hide-details
          label="س"
        type="number"
        min="1300"
        max="2000"
        />
      </v-col>
  
      <v-col cols="5" class="pa-0">
        <v-text-field
          class="rm-fieldset-mr"
          :value="miladiDate"
          readonly
          outlined
          dense
          hide-details
          label="الميلادي المقابل"
        />
      </v-col>
    </v-row>
  </template>
  
  <script>
  import moment from 'moment-hijri';
  
  export default {
    name: 'NewDateFields',
    props: {
      value: {
        // type: Object,
        // default: () => ({ day: '', month: '', year: '' }),
      },
      defaultHijri: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        localHijri: { ...this.value },
      };
    },
    computed: {
      miladiDate() {
        const { day, month, year } = this.localHijri;
        if (day && month && year) {
          const hijriStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          const m = moment(hijriStr, 'iYYYY-iMM-iDD');
          return m.isValid() ? m.format('YYYY-MM-DD') : 'تاريخ غير صالح';
        }
        return '';
      },
    },
    watch: {
        localHijri: {
    handler(newVal) {
      const { day, month, year } = newVal;
      if (day && month && year && year > 1300) {
        const hijriFormatted = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const m = moment(hijriFormatted, 'iYYYY-iMM-iDD');

        if (m.isValid()) {
          // Emit object and formatted values only if valid
          // this.$emit('input', newVal);
          this.$emit('input', hijriFormatted);
          this.$emit('update:hijri', hijriFormatted);
          this.$emit('update:miladi', m.format('YYYY-MM-DD'));
                      console.log("hijriFormatted", hijriFormatted, this.miladiDate)
        }
      }
    },
    deep: true,
  },
    //     localHijri: {
    //         handler(newVal) {
    //         // Emit raw object
    //         this.$emit('input', newVal);

    //         // Format as hijri yyyy-mm-dd
    //         const hijriFormatted = `${newVal.year}-${String(newVal.month).padStart(2, '0')}-${String(newVal.day).padStart(2, '0')}`;
    //         this.$emit('update:hijri', hijriFormatted);
    //             console.log("hijriFormatted", hijriFormatted, this.miladiDate)
    //         // Also emit converted miladi date
    //         this.$emit('update:miladi', this.miladiDate);
    //         },
    //         deep: true,
    //     },
    },
    created() {
    if (this.defaultHijri) {
      const m = moment(this.defaultHijri, 'iYYYY-iMM-iDD');
      if (m.isValid()) {
        this.localHijri = {
          year: m.iYear(),
          month: m.iMonth() + 1,
          day: m.iDate()
        };
      }
    }
  }

  };
  </script>
  <style scoped>
  ::v-deep input[type='number']::-webkit-inner-spin-button,
  ::v-deep input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::v-deep input[type='number'] {
    -moz-appearance: textfield;
  }
 
  </style>
  